"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jsApiHelper = _interopRequireDefault(require("@appfolio/js-api-helper"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var ApiHelper = /*#__PURE__*/function () {
  function ApiHelper() {
    (0, _classCallCheck2["default"])(this, ApiHelper);
    this.jwtStorage = 'jwt';
    this.jwt = void 0;

    this.generateAuthHeader = function (token) {
      return "Bearer ".concat(token);
    };

    this.baseUrl = void 0;

    this.serialize = function (obj, options) {
      return _jsApiHelper["default"].serialize(obj, options);
    };
  }

  (0, _createClass2["default"])(ApiHelper, [{
    key: "getCsrfToken",
    value: function getCsrfToken() {
      var meta = document.querySelector('meta[name="csrf-token"]');
      return meta ? meta.getAttribute('content') : '';
    }
    /**
     *  @type {string | boolean}
     * if non empty string, used as key to store/retrieve jwt from localStorage;
     * if false, disables caching jwt to localStorage
    */

  }, {
    key: "pathHelper",

    /**
     * Appends path to baseUrl if baseUrl is set
     *
     * @param {string} path
     * @returns {string}
     */
    value: function pathHelper(path) {
      if (this.baseUrl) {
        return new URL(path, this.baseUrl).href;
      }

      return path;
    }
    /**
     * Uses this.generateAuthHeader to format token
     * @returns {string} token
     */

  }, {
    key: "getFormattedJwtToken",
    value: function getFormattedJwtToken() {
      if (this.jwt) return this.generateAuthHeader(this.jwt);
      if (!this.jwtStorage) return null;
      var token = window.localStorage.getItem(this.jwtStorage);
      if (!token) return '';
      return this.generateAuthHeader(token);
    }
    /**
     * If 'X-JWT' header found, saves jwt token to localStorage wtih 'jwt' key
     *
     * @param {Headers} headers
     * @returns {void}
     */

  }, {
    key: "saveJwtTokenFromHeader",
    value: function saveJwtTokenFromHeader(headers) {
      if (!this.jwtStorage) return;
      var jwtHeader = headers.get('X-JWT');
      if (jwtHeader) window.localStorage.setItem(this.jwtStorage, jwtHeader);
    }
    /**
     * Refer to: https://github.com/ljharb/qs#stringifying
     */

  }, {
    key: "get",

    /**
     * Perform an HTTP GET to the API and parse the response as JSON
     */
    value: function () {
      var _get = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(path, params) {
        var options,
            headers,
            newOptions,
            response,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
                  convertCase: true,
                  // deprecated
                  convertResponseCase: true,
                  convertRequestCase: true,
                  serializeOptions: {}
                };
                headers = _objectSpread({
                  Authorization: this.getFormattedJwtToken()
                }, options.headers);
                newOptions = _objectSpread(_objectSpread({}, options), {}, {
                  headers: headers
                });
                _context.next = 5;
                return _jsApiHelper["default"].get(this.pathHelper(path), params, newOptions);

              case 5:
                response = _context.sent;
                this.saveJwtTokenFromHeader(response.response.headers);
                return _context.abrupt("return", response.data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Perform an HTTP POST to the API and parse the response as JSON
     */

  }, {
    key: "post",
    value: function () {
      var _post = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(path, body) {
        var options,
            headers,
            newOptions,
            response,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {
                  convertCase: true,
                  // deprecated
                  convertResponseCase: true,
                  convertRequestCase: true
                };
                headers = _objectSpread({
                  'X-CSRF-Token': this.getCsrfToken(),
                  Authorization: this.getFormattedJwtToken()
                }, options.headers);
                newOptions = _objectSpread(_objectSpread({}, options), {}, {
                  headers: headers
                });
                _context2.next = 5;
                return _jsApiHelper["default"].post(this.pathHelper(path), body, newOptions);

              case 5:
                response = _context2.sent;
                this.saveJwtTokenFromHeader(response.response.headers);
                return _context2.abrupt("return", response.data);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function post(_x3, _x4) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
    /**
     * Perform an HTTP PUT to the API and parse the response as JSON
     */

  }, {
    key: "put",
    value: function () {
      var _put = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(path, body) {
        var options,
            headers,
            newOptions,
            response,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {
                  convertCase: true,
                  // deprecated
                  convertResponseCase: true,
                  convertRequestCase: true
                };
                headers = _objectSpread({
                  'X-CSRF-Token': this.getCsrfToken(),
                  Authorization: this.getFormattedJwtToken()
                }, options.headers);
                newOptions = _objectSpread(_objectSpread({}, options), {}, {
                  headers: headers
                });
                _context3.next = 5;
                return _jsApiHelper["default"].put(this.pathHelper(path), body, newOptions);

              case 5:
                response = _context3.sent;
                this.saveJwtTokenFromHeader(response.response.headers);
                return _context3.abrupt("return", response.data);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function put(_x5, _x6) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Perform an HTTP DELETE to the API
     */

  }, {
    key: "del",
    value: function () {
      var _del = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(path, body) {
        var options,
            headers,
            newOptions,
            response,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {
                  convertCase: true,
                  convertResponseCase: true,
                  convertRequestCase: true
                };
                headers = _objectSpread({
                  'X-CSRF-Token': this.getCsrfToken(),
                  Authorization: this.getFormattedJwtToken()
                }, options.headers);
                newOptions = _objectSpread(_objectSpread({}, options), {}, {
                  headers: headers
                });
                _context4.next = 5;
                return _jsApiHelper["default"].del(this.pathHelper(path), body, newOptions);

              case 5:
                response = _context4.sent;
                this.saveJwtTokenFromHeader(response.response.headers);
                return _context4.abrupt("return", response.data);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function del(_x7, _x8) {
        return _del.apply(this, arguments);
      }

      return del;
    }()
    /**
     * Perform an HTTP PATCH to the API and parse the response as JSON
     */

  }, {
    key: "patch",
    value: function () {
      var _patch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(path, body) {
        var options,
            headers,
            newOptions,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {
                  convertCase: true,
                  // deprecated
                  convertResponseCase: true,
                  convertRequestCase: true
                };
                headers = _objectSpread({
                  'X-CSRF-Token': this.getCsrfToken(),
                  Authorization: this.getFormattedJwtToken()
                }, options.headers);
                newOptions = _objectSpread(_objectSpread({}, options), {}, {
                  headers: headers
                });
                _context5.next = 5;
                return _jsApiHelper["default"].patch(this.pathHelper(path), body, newOptions);

              case 5:
                response = _context5.sent;
                this.saveJwtTokenFromHeader(response.response.headers);
                return _context5.abrupt("return", response.data);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function patch(_x9, _x10) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
  }]);
  return ApiHelper;
}();

var api = new ApiHelper();
var _default = api;
exports["default"] = _default;